<template>
	<div
		v-if="customerHasRegistries"
		class="flex flex-between list-registry"
	>
		<ui-button
			color="white"
			@click.stop.prevent="getRegistryList"
			:asset-icon="{ src: '/assets/images/registry/reglists-fill.svg', size: 30 }"
			size="full"
		>
			Add to Registry or List
		</ui-button>
		<!-- Modal -->
		<registry-modal
			v-if="showModal"
			:registry-list="registryList"
			@cancel="cancel"
			@add-to-registry="addToRegistry"
			:loading="loading"
			:added-registry="addedRegistry"
		/>
	</div>
</template>

<script>
import RegistryModal from '../../components/RegistryModal.vue';
export default {
	name: 'ListAndRegistry',
	components: { RegistryModal },
	computed: {
		customerHasRegistries() {
			return this.$store.state.customerHasRegistries;
		},
	},
	data() {
		return {
			addToList: false,
			addedRegistry: null,
			loading: false,
			registryList: null,
			showModal: false,
		};
	},
	methods: {
		getRegistryList() {
			this.loading = this.showModal = true;
			this.$store.dispatch('getRegistryList')
				.then(res => {
					if (!res.success) return;
					const { customerLists } = res;
					if (customerLists && customerLists.length >= 1) this.registryList = customerLists;
					this.loading = false;
				})
				.catch(this.handleError);
		},
		cancel() {
			this.showModal = this.loading = false;
			this.addedRegistry = null;
		},
		addToRegistry(id) {
			if (id === 0) return;
			this.loading = true;
			this.$store.dispatch('addProductToRegistry', id)
				.then(res => {
					if (res.Success) {
						this.addedRegistry = this.registryList.find(list => {
							return list.ID === parseInt(id);
						});
						this.loading = false;
					} else {
						this.loading = false;
					}
				}).catch(this.handleError);
		},
		handleError(err) {
			bugsnagClient.notify(err);
		}
	}
};
</script>

<style lang="less" scoped>
.full-width {
	width: 100%;
}
.list-registry {
	margin: 10px 10px 0 10px;
}
</style>